class Monitoring.Views.SocialContents.SocialContentAppleStoreSearchView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content_apple.jst.ejs']

  initialize: (options = {}) ->
    @model = options.model

  render: ->
    @$el.html @template
      name: @model.getValue 'type'
    this
